import { Link } from 'react-router-dom';
import { Code2 } from 'lucide-react';
import type { HistoryItem } from '../lib/types';
import { ScorePill } from './ScorePill';
import { relativeDate } from '../lib/format';
import styles from './LeftRail.module.css';

interface Props {
  history: HistoryItem[];
  onViewSource: () => void;
  className?: string;
}

export function LeftRail({ history, onViewSource, className }: Props) {
  return (
    <aside className={[styles.rail, className].filter(Boolean).join(' ')} aria-label="Recent analyses">
      <div className={styles.inner}>
        {history.length > 0 && (
          <details className={styles.history} open>
            <summary className={styles.summary}>
              <span className={styles.eyebrow}>Recent ({history.length})</span>
            </summary>
            <ul className={styles.historyList}>
              {history.slice(0, 6).map((h) => (
                <li key={h.id}>
                  <Link to={`/result/${h.slug}`} className={styles.historyItem}>
                    <span className={styles.historyTitle}>{h.title}</span>
                    <span className={styles.historyMeta}>
                      <ScorePill verdict={h.verdict} size="sm" />
                      <time dateTime={h.date}>{relativeDate(h.date)}</time>
                    </span>
                  </Link>
                </li>
              ))}
            </ul>
            {history.length > 6 && (
              <Link to="/history" className={styles.seeAll}>
                See all {history.length} →
              </Link>
            )}
          </details>
        )}

        <button type="button" className={styles.viewSource} onClick={onViewSource}>
          <Code2 size={14} strokeWidth={1.5} aria-hidden="true" />
          View source
        </button>
      </div>
    </aside>
  );
}
